module.exports = __webpack_public_path__ + "static/media/Vania Ramírez cv Español.656aa868.pdf";